import { ApiEndpointConfig } from './api-endpoint-config';

const ENDPOINTS: Record<string, ApiEndpointConfig> = {
  prepareEditor: {
    method: 'post',
    url: 'online-ide/editor-deployment',
    showErrorMsg: false
  },
  runApp: {
    method: 'post',
    url: 'online-ide/editor-deployment/{deploymentName}/run-app'
  },
  stopApp: {
    method: 'post',
    url: 'online-ide/editor-deployment/{deploymentName}/stop-app'
  },
  gitPull: {
    method: 'post',
    url: 'online-ide/editor-deployment/{deploymentName}/git-pull'
  },
  gitPush: {
    method: 'post',
    url: 'online-ide/editor-deployment/{deploymentName}/git-push'
  },
  switchEditorMode: {
    method: 'post',
    url: 'online-ide/editor-deployment/{deploymentName}/switch-mode'
  }
};

// Programmatically add serviceType to all endpoints
Object.values(ENDPOINTS).forEach((api) => {
  (api as any).serviceType = 'codeIDE';
});

export const CODE_EDITOR_API_CONSTANTS = ENDPOINTS as typeof ENDPOINTS &
  Record<keyof typeof ENDPOINTS, { serviceType: string }>;
